import { Button, Col, Modal, Row } from "antd";
import PagePolicy from "component/page/page_policy";
import PageTerm from "component/page/page_term";
import { useActionTermAndPolicy } from "hook/term/useActionTerm";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogPrivacyPolicy = () => {
  // -------------------------- VAR -----------------------------
  const { policy } = useActionTermAndPolicy();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      open={policy.open}
      onCancel={policy.handleClose}
      title="QUY CHẾ BẢO VỆ DỮ LIỆU CÁ NHÂN"
      footer={null}
    >
      <Row gutter={[0, 16]}>
        <Col xl={24} lg={24} md={24} xs={24}>
          <div className="h-[550px] overflow-auto border-[1px] border-gray-300">
            <PagePolicy />
          </div>
        </Col>
        <Col align="right" xl={24} lg={24} md={24} xs={24}>
          <Button onClick={() => policy.handleClose()} type="primary">
            Đã xem
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};
export default DialogPrivacyPolicy;
